import './SupportPage.css';

function SupportPage() {

  return (
    <>
    <h1>/dev/agents</h1>
    <h3>Support</h3>

    <p>If you have any questions or feedback, please contact us at <a href="mailto:support@sdsa.ai">support@sdsa.ai</a></p>
    </>
  );
}

export default SupportPage;
